import { render, staticRenderFns } from "./GDPRLinks.vue?vue&type=template&id=10f2e714&lang=pug&"
import script from "./GDPRLinks.vue?vue&type=script&lang=js&"
export * from "./GDPRLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports